import { Outlet, useLocation } from 'react-router-dom'
import { PcHeader } from '@widgets/pc-header'
import { PcFooter } from '@widgets/pc-footer'

// 거래화면(/trade)은 풀높이 레이아웃이라 푸터 없음
const NO_FOOTER_PATHS = ['/trade']

export const PcLayout = () => {
  const { pathname } = useLocation()
  const showFooter = !NO_FOOTER_PATHS.includes(pathname)

  return (
    <div className="flex min-h-screen min-w-[1280px] flex-col bg-[#1b1c1d]">
      <PcHeader />
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
      {showFooter && <PcFooter />}
    </div>
  )
}
